import { SortingState } from '@tanstack/react-table';

import { useFlags } from '~/stores/use-flags/useFlags';
import { create } from '~/utils/store/createStore';

import { getDefaultInsightsFilterState, InsightsAnalysisType } from './utils';

export type InsightsFilterState = Record<
  string,
  { key: InsightsAnalysisType; checked: boolean }[]
>;

type AssetsTableStore = {
  sortingState: SortingState;
  insightsFilterState: InsightsFilterState;
  reset: () => void;
};

export const useAssetsTableStore = create<AssetsTableStore>(set => {
  const isEarningsInsightsEnabled = useFlags
    .getState()
    .getFeatureFlagState('earnings_insights');
  const isCompanyCatalystEnabled = useFlags
    .getState()
    .getFeatureFlagState('catalysts_company_insights');
  const isMarketCatalystEnabled =
    useFlags.getState().getFeatureFlagState('catalysts_theme_insights') ||
    useFlags.getState().getFeatureFlagState('catalysts_geo_insights') ||
    useFlags.getState().getFeatureFlagState('catalysts_macro_insights');

  const initialState = {
    sortingState: [],
    insightsFilterState: getDefaultInsightsFilterState(true, {
      isCompanyCatalystEnabled,
      isEarningsInsightsEnabled,
      isMarketCatalystEnabled,
    }),
  };
  return {
    ...initialState,
    reset: () => {
      set(initialState);
    },
  };
});
